// sans manoeuvre + sans dimensions

import formInputsTypes from "../simulatorConstant";


const cableDiametreResistance = {
	id: 'PG-CB-L',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'cableDiametreResistance',
	className: 'col-6',
	label: 'Diamètre / résistance du câble (mm)',
	placeholder: '0',
	defaultValue: 0,
	nextStep: false,
	validation: (value) => value >= 0,
};

export const cableLongueur = {
	id: 'PG-CB-L',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'cableLongueur',
	className: 'col-6',
	label: 'Longueur du câble (mm)',
	placeholder: '0',
	defaultValue: 0,
	nextStepData: cableDiametreResistance,
	validation: (value) => value >= 0,
};
